import crypto from 'crypto';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export type HelpscoutUser = {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
};

export const hsSignature = (email?: string | null) => {
  if (!email || !publicRuntimeConfig?.beaconSecret) {
    return undefined;
  }

  return crypto.createHmac('sha256', publicRuntimeConfig.beaconSecret).update(email).digest('hex');
};

export const buildIdentifyPayload = (user: HelpscoutUser) => {
  if (!user?.email) {
    return undefined;
  }

  const payload: Record<string, unknown> = {
    email: user.email,
    signature: hsSignature(user.email),
  };

  const name = `${user.firstName || ''} ${user.lastName || ''}`.trim();

  if (name) {
    payload.name = name;
  }

  return payload;
};
